<template>
    <div  class="body-inner">
        <header-landing-component></header-landing-component>


        <!-- end: Header -->
        <!-- Inspiro Slider -->
        <div id="slider" class="inspiro-slider dots-creative" data-height-xs="360">
            <!-- Slide 2 -->
            <div class="slide kenburns" style="background-image:url('../../assets/images/its_bg_banner.jpg');">
                <div class="bg-overlay"></div>
                <div class="container">
                    <div class="slide-captions text-center text-light">
                        <!-- Captions -->
                        <span class="strong">Certificaciones</span>
                        <h1>Information Technology Specialist<br>
<span style="font-size: 2.55rem"></span></h1>
                        <!-- end: Captions -->
                    </div>
                </div>
            </div>
            <!-- end: Slide 2 -->

        </div>
        <!--end: Inspiro Slider -->

        <section>
            <div class="container">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="heading-text heading-section">
                            <h2 style="font-size: 2.85rem">LA<span style="color:#66C0FF"> TECNOLOGÍA</span> EMPIEZA AQUÍ</h2>

                        </div>
						<img src="../../assets/images/certificaciones/its.png" class="mb-4">
                    </div>
                    <div class="col-lg-8">
                        <div class="row">
                            <div class="col-lg-10">
								
							<p>El programa de Especialista en Tecnología de la Información es una forma en la que los estudiantes pueden validar las habilidades básicas en TI que buscan los empleadores. El programa de Especialista en TI está dirigido
a candidatos que están considerando,o recién empezando, un camino hacia una carrera profesional en tecnología de la información.<br><br>
Los estudiantes pueden certificar su conocimiento en un amplio rango de temas relacionados con la TI, incluyendo desarrollo de software, administración de bases de datos, conexiones en red
y seguridad, gestión de dispositivos y movilidad, y programación.</p>
								<hr>
								<br>
								
								<h4>BENEFICIOS DE LA CERTIFICACIÓN</h4>
								
								<ul class="list-icon list-icon-check">
									<li><strong>Preparación para el futuro</strong> —
Ayude a sus alumnos a ser más competitivos. Ser Especialista en
TI es el primer paso para lograr certificaciones más avanzadas,
lo que ayudará a sus estudiantes a elevar su valor en el mercado laboral.</li>

<li><strong>Carreras profesionales</strong> — La certificación como Especialista
en TI indica que los estudiantes están preparados para comenzar a solicitar trabajos de nivel inicial en tecnología, como por ejemplo, prácticas y pasantías.</li>

<li><strong>Confianza</strong> — Las credenciales reconocidas por la industria inspiran confianza a medida que los estudiantes persiguen futuras aspiraciones universitarias y profesionales.</li>
								
								</ul>
							
							
							</div>

                         

                        </div>
                    </div>

                </div>
                <div class="row mt-5">
                    <div class="col-12 text-center">
                        <p class="gca-title-big">CERTIFICADO OFICIAL</p>
                    </div>
                    <div class="col-12 text-center">
                        <img src="../../assets/images/carousel/Sample_Certificate_ITS.jpg" width="100%" alt="">
                    </div>
                </div>
            </div>
        </section>

		
		<section>
		 <div class="container">
			 <h3 class="text-center">Exámenes de certificación como Especialista en TI</h3>
            <div class="row">
				
				<div class="col-md-4"><strong>Bases de datos</strong> — Los candidatos
para este examen necesitarán probar un conocimiento introductorio
y habilidades con las bases de datos, incluyendo bases de datos relacionales como Microsoft SQL Server o Windows Azure SQL Database. <br><br>
<strong>Desarrollo de software</strong> —
Los candidatos para este examen buscan demostrar habilidades básicas de desarrollo de software. <br><br>
<strong>Conexión en red</strong> — Los candidatos para este examen deberán probar que tienen conocimientos y habilidades básicos sobre conexiones en red.
Seguridad de redes — Los candidatos para este examen deberán validar que poseen conocimientos y habilidades básicos sobre seguridad.</div>
				
				<div class="col-md-4">
					
					<strong>JavaScript</strong> — Los candidatos para
este examen deben ser capaces
de reconocer y escribir código JavaScript sintácticamente correcto, utilizar tipos de datos compatibles
con JavaScript y reconocer y escribir código JavaScript que resolverá lógicamente un problema determinado.<br><br>
					
<strong>Java</strong> — Los candidatos para este examen requieren instrucción y/o experiencia práctica con Java, estar familiarizados con sus características y capacidades, y entender cómo escribir, depurar y mantener un código Java bien formado y documentado.<br><br>
					
<strong>Python</strong> — Los candidatos para este examen deben ser capaces de reconocer y escribir código Python sintácticamente correcto, reconocer tipos de datos compatibles con Python, y reconocer
y escribir código Python que resolverá lógicamente un problema determinado. </div>
				
				<div class="col-md-4">
					
					<strong>HTML y CSS</strong> — Los candidatos para este examen deben ser capaces de reconocer y escribir HTML y CSS sintácticamente correctos, estructurar datos utilizando elementos HTML, y crear y aplicar estilos utilizando CSS.
					
                    <strong>Desarrollo de aplicaciones en HTML5</strong> — Los candidatos para este examen buscan demostrar su habilidad en el
uso de HTML5, CSS y JavaScript para crear aplicaciones web adaptables
que se ejecutarán en una variedad de dispositivos táctiles, incluyendo computadoras personales, tabletas y teléfonos.
					
                    <strong>Configuración y gestión de dispositivos</strong> — Los candidatos para este examen
deben tener habilidades y conocimientos básicos sobre dispositivos de Windows
y movilidad. </div>
                
              
               
            </div>
		 </div>
        </section>

        <section class="section-fullwidth text-light p-b-0">
            <div class="row">
                
              <img src="../../assets/images/its-exams.jpg" class="img-fluid">

               
            </div>
        </section>

        <!--call-to-action dark -->
        <div class="call-to-action p-t-100 p-b-100  mb-0 call-to-action-dark">
            <div class="container">
                <div class="row">
                    <div class="col-lg-10">
                        <h3>
                            ¿Quieres agregar esta credencial con validez internacional a tu CV?
                        </h3>
                        <p>
                            Conoce todas las soluciones que Global Certification Academy ofrece para agregar VALOR A TU CURRÍCULUM.
                        </p>
                    </div>
                    <div class="col-lg-2"><router-link class="btn btn-primary btn-lg" to="/register">INSCRIBIRME</router-link></div>
                </div>
            </div>
        </div>
        <!--end: call-to-action dark -->

        <LeadComponent></LeadComponent>
        <footer-landing-component></footer-landing-component>
        
    </div>
</template>

<script>
    import HeaderLandingComponent from "../../components/Landing/HeaderLandingComponent.vue"
    import FooterLandingComponent from "../../components/Landing/FooterLandingComponent.vue"
    import LeadComponent from "../../components/Landing/LeadComponent.vue"
	export default {
		name: 'its',
        components: {
			HeaderLandingComponent,
            FooterLandingComponent,
            LeadComponent
		},   
		data() {
			return {
            }
        },
		methods: {
        },
		mounted() {
        }        
    }

</script>